<template>
	<div class="sf-flex-column h-100">
		<sf-data-table
			ref="mainTable"
			:pageUnit="pagingInfo.pageUnit"
			:totalSize="pagingInfo.totalSize"
			paging
			index
			:columns="mainColumns"
			:rows="mainRows"
			:stripe="false"
			:excel="isButton_(scrId, 'EX')"
			@changedPage="changedPage"
		>
			<template v-slot:customRows="slotProps">
				<template v-if="slotProps.column.property === 'mesEqipNo'">
					<!-- 가동상태 : 정상, 교정상태 : 입고, 성적서번호 존재할 때 -->
					<template v-if="slotProps.row.runStCd === 'NORM' && slotProps.row.calStCd === 'WHSN' && !!slotProps.row.rslrNo">
						<span class="highlighted" @click="() => clickMesEqipNo(slotProps.row)" style="cursor: pointer">
							{{ slotProps.row.mesEqipNo }}
						</span>
					</template>
					<template v-else>
						<span>
							{{ slotProps.row.mesEqipNo }}
						</span>
					</template>
				</template>
				<template v-if="slotProps.column.property === 'rslrFile'">
					<template v-if="slotProps.row.rslrFileId">
						<span @click="() => onDownloadFile(slotProps.row.rslrFileId)" style="cursor: pointer">
							<img src="/img/common/table/icon-sf-excel.svg" alt="excel icon" class="mr-1" />
						</span>
					</template>
				</template>
			</template>
		</sf-data-table>
		<!-- pop up -->
		<report-popup ref="popupReport" @Refresh="refresh" :scrId="scrId"></report-popup>
	</div>
</template>

<script>
import ReportPopup from '../Report/ReportPopup.vue';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mmc/mmcm/MesCal/store/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { ReportPopup },
	methods: {
		...rootMethods,
		...serviceMethods,
		clickMesEqipNo(row) {
			this.$refs.popupReport.open(row);
		},
		async onDownloadFile(fileId) {
			await this.fileDownload_({ fileId, fileSeq: 1 });
		},
		refresh() {
			this.$emit('Refresh');
		},
		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회했기 때문에 중복 조회 하지않도록 처리
				return;
			}
			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });
			this.$emit('Refresh');
		}
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		mainRows() {
			return this.resultList;
		},
		mainColumns() {
			return [
				{
					label: this.getMessage_('QWCC001317'), //관리번호
					prop: 'mesEqipNo',
					minWidth: '100px',
					custom: true
				},
				{
					label: this.getMessage_('QWCC001314'), //장비명
					prop: 'mesEqipNm',
					minWidth: '130px'
				},
				{
					label: this.getMessage_('QWCC001318'), //제조사
					prop: 'mkrNm',
					minWidth: '100px'
				},
				{
					label: this.getMessage_('QWCC001319'), //모델명
					prop: 'mdlNm',
					minWidth: '120px'
				},
				{
					label: this.getMessage_('QWCC001579'), //교정업체
					prop: 'calInstCd',
					minWidth: '160px',
					form: {
						type: 'select',
						placeholder: ' - ',
						options: this.calInstCdList,
						isDisabled: () => true // 에디트 방지
					}
				},
				{
					label: this.getMessage_('QWCC001597'), //교정일자
					prop: 'calCmplDd',
					minWidth: '90px'
				},
				{
					label: this.getMessage_('QWCC001361'), //입고일시
					prop: 'whsnDd',
					minWidth: '90px'
				},
				{
					label: this.getMessage_('QWCC001348'), //성적서번호
					prop: 'rslrNo',
					minWidth: '1px'
				},
				{
					label: this.getMessage_('QWCC001628'), //성적서
					prop: 'rslrFile',
					minWidth: '60px',
					custom: true
				},
				{
					label: this.getMessage_('QWCC001345'), //교정결과
					prop: 'calRsltCd',
					minWidth: '70px',
					form: {
						type: 'select',
						placeholder: ' - ',
						options: this.calRsltCdList,
						isDisabled: () => true // 에디트 방지
					}
				},
				{
					label: this.getMessage_('QWCC001323'), //교정주기
					prop: 'calCyclCd',
					minWidth: '90px',
					form: {
						type: 'select',
						placeholder: ' - ',
						options: this.calCyclCdList,
						isDisabled: () => true // 에디트 방지
					}
				},
				{
					label: this.getMessage_('QWCC001324'), //차기교정일
					prop: 'nextCalDd',
					minWidth: '90px',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC001347'), //교정비용
					prop: 'calExp',
					minWidth: '90px'
				},
				{
					label: this.getMessage_('QWCC001912'), //교정예산
					prop: 'calBudg',
					minWidth: '90px'
				},
				{
					label: this.getMessage_('QWCC001315'), //가동상태
					prop: 'runStCd',
					minWidth: '70px',
					form: {
						type: 'select',
						placeholder: ' - ',
						options: this.runStCdList,
						isDisabled: () => true // 에디트 방지
					}
				},
				{
					label: this.getMessage_('QWCC001316'), //교정상태
					prop: 'calStCd',
					minWidth: '70px',
					form: {
						type: 'select',
						placeholder: ' - ',
						options: this.calStCdList,
						isDisabled: () => true // 에디트 방지
					}
				}
			];
		}
	}
};
</script>
